module.exports = __webpack_public_path__ + "img/offer3.e0788610.jpg";